import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-669f0ea2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Charts = _resolveComponent("Charts")!
  const _component_dataLoad = _resolveComponent("dataLoad")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_dataLoad, { spinning: _ctx.spinning }, {
      default: _withCtx(() => [
        (!_ctx.spinning)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_Charts, {
                id: "hyqzChart",
                option: _ctx.option
              }, null, 8, ["option"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}